import { IconProps } from '../icon';

export function ContactIcon(props: IconProps) {
  return (
    <svg
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M28 3.16675H7.99999C7.29275 3.16675 6.61447 3.4477 6.11437 3.9478C5.61427 4.44789 5.33332 5.12617 5.33332 5.83341V9.83341H2.66666V12.5001H5.33332V15.1667H2.66666V17.8334H5.33332V20.5001H2.66666V23.1667H5.33332V27.1667C5.33332 27.874 5.61427 28.5523 6.11437 29.0524C6.61447 29.5525 7.29275 29.8334 7.99999 29.8334H28C28.3536 29.8334 28.6927 29.6929 28.9428 29.4429C29.1928 29.1928 29.3333 28.8537 29.3333 28.5001V4.50008C29.3333 4.14646 29.1928 3.80732 28.9428 3.55727C28.6927 3.30722 28.3536 3.16675 28 3.16675V3.16675ZM17.3333 7.16541C19.5307 7.16541 21.3333 8.96675 21.3333 11.1654C21.3295 12.2252 20.9068 13.2405 20.1576 13.99C19.4083 14.7396 18.3931 15.1625 17.3333 15.1667C15.1373 15.1667 13.3333 13.3627 13.3333 11.1654C13.3333 8.96675 15.1373 7.16541 17.3333 7.16541ZM25.3333 24.5001H9.33332V23.5001C9.33332 20.5414 12.94 17.5001 17.3333 17.5001C21.7267 17.5001 25.3333 20.5414 25.3333 23.5001V24.5001Z"
        fill="#83B735"
      />
    </svg>
  );
}

export default ContactIcon;
